import axios from "axios";
import { tokenManager } from "utils/tokenManager";

const KPI_API_BASE = "https://usibras-web-backend.onrender.com/api";

/**
 * Create one evaluation score (one KPI row).
 *
 * @param {Object} data
 * @param {string} data.evaluation_id - e.g. "ev-1739234567890"
 * @param {string} data.evaluatee_id - Worker/user ID
 * @param {string} data.evaluatee_name - Worker name
 * @param {string} data.sector_id - Sector ID
 * @param {string} data.sector_name - Sector name
 * @param {string} data.evaluatee_role - "operator" | "supervisor"
 * @param {string} data.kpi_id - KPI metric ID
 * @param {string} data.kpi_name - KPI metric name
 * @param {number} data.score_range - 1-5
 * @param {number|null} [data.score_percentage] - 0-100 or null
 * @param {string} [data.evaluated_at] - "YYYY-MM-DD HH:mm:ss" or ISO
 * @returns {Promise<{ data: Object, message: string }>}
 */
export async function createEvaluationScore(data) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.post(
    `${KPI_API_BASE}/evaluation-scores`,
    {
      evaluation_id: data.evaluation_id,
      evaluatee_id: data.evaluatee_id,
      evaluatee_name: data.evaluatee_name || "",
      sector_id: data.sector_id,
      sector_name: data.sector_name || "",
      evaluatee_role: data.evaluatee_role || "operator",
      kpi_id: data.kpi_id,
      kpi_name: data.kpi_name || "",
      score_range: data.score_range,
      score_percentage: data.score_percentage != null ? Number(data.score_percentage) : null,
      evaluated_at: data.evaluated_at || null,
    },
    { headers }
  );
  return response.data;
}

/**
 * Get all evaluation scores.
 *
 * @returns {Promise<{ data: Object[], message: string }>}
 */
export async function getEvaluationScores() {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.get(`${KPI_API_BASE}/evaluation-scores`, { headers });
  return response.data;
}
